module.exports = __webpack_public_path__ + "media/misc/student-loan-hero-lendingtree-logo-19e268a3.svg";